import { render, staticRenderFns } from "./ConversationAction.vue?vue&type=template&id=2ccc52d5&"
import script from "./ConversationAction.vue?vue&type=script&lang=js&"
export * from "./ConversationAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports